import paths from '../../routes/paths'
import { SA_SAFE_HEALTH_PATH } from './saasAdmin.constants'

export function isNullishCount(value) {
  return value === null || value === undefined
}

export function displayCount(value, notAvailableLabel) {
  if (isNullishCount(value)) return notAvailableLabel
  return value
}

export function parseSafeNavigationTarget(target) {
  if (!target || typeof target !== 'string') return null
  const match = target.match(SA_SAFE_HEALTH_PATH)
  if (!match) return null
  const companyId = Number(match[1])
  if (!Number.isFinite(companyId)) return null
  return paths.admin.companyHealth(companyId)
}

export function companyDbStatusVariant(status) {
  const s = String(status || '').toLowerCase()
  if (s === 'active') return 'active'
  if (s === 'inactive') return 'inactive'
  if (s === 'licence_expired') return 'licence_expired'
  return 'unknown'
}

export function subscriptionStatusClass(status) {
  return String(status || 'active').toLowerCase().replace(/_/g, '-')
}

export function usageStatusClass(status) {
  return String(status || 'active').toLowerCase().replace(/_/g, '-')
}

export function healthStatusClass(status) {
  return String(status || 'healthy').toLowerCase()
}

export function extractValidationMessage(error) {
  const errors = error?.response?.data?.errors
  if (errors && typeof errors === 'object') {
    const firstKey = Object.keys(errors)[0]
    const first = errors[firstKey]
    if (Array.isArray(first) && first[0]) return first[0]
  }
  return error?.response?.data?.message || error?.message || null
}

export function isSuperAdminUser(userInfo) {
  const roles = userInfo?.roles || []
  if (roles.some((rol) => rol.name === 'Super Admin')) return true
  const sa = userInfo?.super_admin
  return sa === true || sa === 1 || sa === '1'
}

export const PROTECTED_PLATFORM_ADMIN_EMAILS = ['admin@t4app.com']

export function isProtectedPlatformAdmin(user) {
  const email = String(user?.email || '').trim().toLowerCase()
  return PROTECTED_PLATFORM_ADMIN_EMAILS.includes(email)
}
